<svg class={$$props.class} viewBox="0 0 512 512">
  <path
    fill="currentColor"
    d="M464 256h-80v-64a64 64 0 0164-64h8a24 24 0 0024-24V56a24 24 0
    00-24-24h-8a160 160 0 00-160 160v240a48 48 0 0048 48h128a48 48 0
    0048-48V304a48 48 0 00-48-48zm-288 0H96v-64a64 64 0 0164-64h8a24 24 0
    0024-24V56a24 24 0 00-24-24h-8A160 160 0 000 192v240a48 48 0 0048 48h128a48
    48 0 0048-48V304a48 48 0 00-48-48z" />
</svg>
